import { InternalFormState, MutableState, setIn } from 'final-form';

export const setFormState = <T>(args: [keyof InternalFormState, unknown], state: MutableState<T, Partial<T>>) => {
  const [key, value] = args;
  state.formState = setIn(state.formState, key, value) as InternalFormState;
};

